export enum DeliveryTypes {
    Route = 1,
    STAT
};

export enum orderStatusEnums {
    Placed = 1,
    Offered, 
    DriverInbound,
    OutForDelivery,
    ReturnInbound,
    Complete,
    Cancelled,
    Created,
    UnmappedAddress
};

export enum serviceTypeEnums {
    Route = 1,
    Stat,
    MultiStat,
    Overnight,
    NextDay,
    TwoHourStat,
    FourHourStat
};

export enum tripStatusEnums {
    Offered = 1,
    InProgress,
    Unassigned,
    Completed,
    Cancelled,
    InReview
};

export enum billingTypes {
    Stat = 1,
    MultiStat,
    Route,
    ReturnToPharmacy,
    LineHaul,
    Addon,
}

export enum billingStatus {
    New = 1,
    Invoiced,
    Complete
}

export enum orderSources {
    OrderForm = 1,
    Interfaces
}

export enum OrderTypes {
    Delivery = 1,
    Return
}

export enum Tenants {
    AllmedExpress = 1,    
    AnytimeParcel = 2,
	Omnicare = 3
}

export enum BillRunItemIssueSeverities
{
    Warning = 1,
    Exception
}

export enum BillRunItemIssueTypes
{
    MissingRate = 1,
    NotProfitable,
    TripNotComplete
}

export enum FormatSettings
{
    SortableDateTime = 1,
    GeneralDateTime,
    Date,
    Time,
    Yn,
    YesNo,
    Currency,
    TwentyFourHrTime
}

export enum FormatCategories
{
    Date = 1,
    Boolean,
    Numeric,
    ServiceType
}

export enum CustomEditorOptions
{
    Date = 1,
    Time,
    DateTime,
    ServiceType,
    InvoiceStatus,
    DisputeStatus
}

export enum TripTypes
{
    HomeHealth = 1,
    Ltc
}

export enum DeliveryStatuses
{
    NotAvailable = 0,
    Delivered = 1,
    Partial,
    Undeliverable
}

export enum PackageDeliveryStatuses
{
    Unknown = 0,
    Delivered = 1,
    Refused,
    Attempted,
    Partial,
    Other,
    NotPickedUp
}

export enum PackagePickupStatuses
{
    Unknown = 0,
    PickedUp = 1,
    Cancelled,
    Damaged,
    NotAvailable,
    Other
}

export enum PaymentMethods
{
    PerStop = 1,
    PerMile,
    PerTrip,
    PerStationWing,
    ByWeight,
    BySizeDimension,
    ByTime,
    FuelSurcharge,
    Discount,
    Base
}

export enum BillingMethods
{
    PerStop = 1,
    PerMile,
    PerTrip,
    PerStationWing,
    ByWeight,
    BySizeDimension,
    ByTime,
    FuelSurcharge,
    Discount,
    Base
}

export enum AddressBookEntryTypes {
    AssistedLiving = 1,
    CartDoctorService,
    CustomerSite,
    Hospice,
    Hospital,
    Other,
    PharmacyStaging,
    PrivateResidence,
    RehabCenter,
    SkilledNursingFacility,
    Storage,
    Pickup,
    ZipCode
}

export enum MappingProviders {
    Manual,
    Mapbox,
    ArcGIS,
    Google
}

export enum DeliveryDayOption {
    AnyFutureDateOrTimeAfterOrderPlacement = 0,
    OnOrAfterNextDayFollowingOrderPlacement = 1,
    SameDayAsOrderPlacement = 2
}

export enum DeliveryWindowType {
    None = 0,
    By = 1,
    ByOrAfter = 2
}